import ComparisonDialog from './ComparisonDialog';

export default ComparisonDialog;
